import script from "./RegistrationWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationWizard.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationWizard.vue?vue&type=style&index=0&id=9c229860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c229860"]])

export default __exports__